import { CentrifugeClient } from "./ws-client.js";
class CentrifugePublicClient extends CentrifugeClient {
  constructor(apiUrl, handler) {
    super();
    this.apiUrl = apiUrl;
    this.handler = handler;
    this.setPageHideListeners();
  }
  static async create(apiUrl, isProtoBuf = false) {
    const url = apiUrl + "?cf_protocol_version=v2";
    if (isProtoBuf) {
      const { Centrifuge: CentrifugeProto } = await import("centrifuge/build/protobuf");
      return new CentrifugePublicClient(url, new CentrifugeProto(url));
    } else {
      const { Centrifuge } = await import("centrifuge");
      return new CentrifugePublicClient(url, new Centrifuge(url));
    }
  }
}
export {
  CentrifugePublicClient
};
